module.exports = __webpack_public_path__ + "img/wind-loads.fa46cbe7.png";